module.exports = __webpack_public_path__ + "media/flags/mt-a63f527d.svg";